import { render, staticRenderFns } from "./sidebar-header.vue?vue&type=template&id=af0a44ba&scoped=true&lang=pug&"
import script from "./sidebar-header.vue?vue&type=script&lang=coffee&"
export * from "./sidebar-header.vue?vue&type=script&lang=coffee&"
import style0 from "./sidebar-header.vue?vue&type=style&index=0&id=af0a44ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0a44ba",
  null
  
)

export default component.exports